const OptionsIcon = ({ height, styles }) => {
  return (
    <svg
      height={height}
      styles={styles}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6.54261 14.0089H10.3076C13.4451 14.0089 14.7 12.7539 14.7 9.61642V5.85145C14.7 2.71397 13.4451 1.45898 10.3076 1.45898H6.54261C3.40514 1.45898 2.15015 2.71397 2.15015 5.85145V9.61642C2.15015 12.7539 3.40514 14.0089 6.54261 14.0089Z"
        stroke="#EFF1F5"
        strokeWidth="1.41186"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.9331 7.73172H10.9387"
        stroke="#EFF1F5"
        strokeWidth="1.88249"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.42236 7.73172H8.428"
        stroke="#EFF1F5"
        strokeWidth="1.88249"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.91186 7.73172H5.9175"
        stroke="#EFF1F5"
        strokeWidth="1.88249"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default OptionsIcon;
